import{useState}from'react'
import{supabase}from'../supabase'
export default function TicketTiers({eventId,tiers,onSaved}){
const[rows,setRows]=useState(tiers.length>0?tiers:[{tier_name:'General Admission',price:'',quantity:''}])
const[saving,setSaving]=useState(false)
function updateRow(i,field,value){
const updated=[...rows]
updated[i]={...updated[i],[field]:value}
setRows(updated)}
function addRow(){setRows([...rows,{tier_name:'',price:'',quantity:''}])}
async function handleSave(){
setSaving(true)
await supabase.from('ticket_tiers').delete().eq('event_id',eventId)
const payload=rows.filter(r=>r.tier_name&&r.price).map(r=>({event_id:eventId,tier_name:r.tier_name,price:parseFloat(r.price)||0,quantity:parseInt(r.quantity)||0}))
await supabase.from('ticket_tiers').insert(payload)
setSaving(false)
onSaved()}
return(<div>
{rows.map((row,i)=>(<div key={i} style={{display:'flex',gap:'8px',marginBottom:'8px'}}>
<input className='input' placeholder='Tier name' value={row.tier_name} onChange={e=>updateRow(i,'tier_name',e.target.value)}/>
<input className='input' type='number' placeholder='Price' value={row.price} onChange={e=>updateRow(i,'price',e.target.value)} style={{width:'100px'}}/>
<input className='input' type='number' placeholder='Qty' value={row.quantity} onChange={e=>updateRow(i,'quantity',e.target.value)} style={{width:'80px'}}/>
</div>))}
<div style={{display:'flex',gap:'8px',marginTop:'8px'}}>
<button className='btn-secondary' onClick={addRow}>+ Add Tier</button>
<button className='btn-primary' onClick={handleSave} disabled={saving}>{saving?'Saving...':'Save Tiers'}</button>
</div></div>)}